import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "photoshopcore"
    }}>{`photoshopCore`}</h1>
    <p>{`The module that allows access to specialized commands
within the application. Various application state can be
modified or queried here.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var PhotoshopCore = require('photoshop').core;
`}</code></pre>
    <h2 {...{
      "id": "variables"
    }}>{`Variables`}</h2>
    <h3 {...{
      "id": "apiversion"
    }}>{`apiVersion`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Let`}</inlineCode>{` `}<strong parentName="p">{`apiVersion`}</strong>{`: `}<em parentName="p">{`number`}</em></p>
    <p>{`API Version declared by the plugin's manifest.json under `}<inlineCode parentName="p">{`host.data.apiVersion`}</inlineCode>{` field.`}</p>
    <p>{`If value 1, you will have access to Photoshop 22.0 DOM and be able to make mutable calls outside a modal state.
If 2, you will have access to latest DOM, modal execution and everything else new we're adding.`}</p>
    <h2 {...{
      "id": "functions"
    }}>{`Functions`}</h2>
    <h3 {...{
      "id": "addnotificationlistener"
    }}>{`addNotificationListener`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Attach a listener to a Photoshop core event. A callback in the form
of `}<inlineCode parentName="p">{`(eventName: string, descriptor: Descriptor) => void`}</inlineCode>{` will be performed.
The event(s) below are supported:`}</p>
    <p>{`group: '`}<inlineCode parentName="p">{`UI`}</inlineCode>{`', event: '`}<inlineCode parentName="p">{`userIdle`}</inlineCode>{`'`}</p>
    <ul>
      <li parentName="ul">{`Invoked after the Photoshop user idles for a specified number of seconds. See `}<a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/media/photoshopcore/#setuseridletime"
        }}>{`setUserIdleTime`}</a>{`.`}</li>
      <li parentName="ul">{`Invoked a second time with the descriptor `}<inlineCode parentName="li">{`{idleEnd: true}`}</inlineCode>{` if the user is no longer idle. This signal can
be used to finish up tasks being performed during the idle time.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await PhotoshopCore.addNotificationListener('UI', ['userIdle'], onUserIdle)
`}</code></pre>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`group`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`events`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em>{`[]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`notifier`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`NotificationListener`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "calculatedialogsize"
    }}>{`calculateDialogSize`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<{ `}<inlineCode parentName="p">{`height`}</inlineCode>{`: `}<em parentName="p">{`number`}</em>{` ; `}<inlineCode parentName="p">{`width`}</inlineCode>{`: `}<em parentName="p">{`number`}</em>{`  }`}{`>`}</p>
    <p>{`Returns the effective size of a dialog.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var idealSize = { width: 200, height: 500 }
{ width, height} = await PhotoshopCore.calculateDialogSize(idealSize)
`}</code></pre>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`preferredSize`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`preferredSize.height`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`preferredSize.width`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`identifier?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`minimumSize?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`minimumSize.height`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`minimumSize.width`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "convertcolor"
    }}>{`convertColor`}</h3>
    <p>{`ColorDescriptor`}</p>
    <p>{`Converts the given color (in descriptor form) to the
given color space, returning the color descriptor.`}</p>
    <p>{`This is an internal API that is used for `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/solidcolor/"
      }}>{`SolidColor`}</a>{`
and all the other color classes.`}</p>
    <p>{`Currently, this API uses the application color settings
for conversion (Edit > Color Settings...). '
In the future, we will provide color conversion
based on embedded color profiles.`}</p>
    <h4 {...{
      "id": "parameters-2"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sourceColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ColorDescriptor`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`targetModel`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ColorConversionModel`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "endmodaltoolstate"
    }}>{`endModalToolState`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`End the current modal tool editing state.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// close the modal dialog, cancelling changes
await PhotoshopCore.endModalToolState(false)
`}</code></pre>
    <h4 {...{
      "id": "parameters-3"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`commit`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "executeasmodal"
    }}>{`executeAsModal`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`ExecuteAsModal is needed when a plugin wants to make modifications to the Photoshop state.
This includes scenarios where the plugin wants to create or modify documents,
or the plugin wants to update UI or preference state.`}</p>
    <p>{`ExecuteAsModal is only available to plugin that is using apiVersion 2 or higher.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "../executeasmodal"
      }}>{`Modal Execution`}</a>{` for details`}</p>
    <h4 {...{
      "id": "parameters-4"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`targetFunction`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`executionContext`}</inlineCode>{`: `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/interfaces/executioncontext/"
            }}><em parentName="a">{`ExecutionContext`}</em></a>{`) => `}<em parentName="td">{`Promise`}</em>{`<any`}{`>`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/interfaces/executeasmodaloptions/"
            }}><em parentName="a">{`ExecuteAsModalOptions`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "getactivetool"
    }}>{`getActiveTool`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<{ `}<inlineCode parentName="p">{`classID`}</inlineCode>{`: `}<em parentName="p">{`string`}</em>{` ; `}<inlineCode parentName="p">{`isModal`}</inlineCode>{`: `}<em parentName="p">{`boolean`}</em>{` ; `}<inlineCode parentName="p">{`key`}</inlineCode>{`: `}<em parentName="p">{`string`}</em>{` ; `}<inlineCode parentName="p">{`title`}</inlineCode>{`: `}<em parentName="p">{`string`}</em>{`  }`}{`>`}</p>
    <p>{`Returns information about the active Photoshop tool.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{ title } = await PhotoshopCore.getActiveTool()
`}</code></pre>
    <hr></hr>
    <h3 {...{
      "id": "getcpuinfo"
    }}>{`getCPUInfo`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/interfaces/cpuinfo/"
      }}><em parentName="a">{`CPUInfo`}</em></a></p>
    <p>{`Returns information about the host CPU.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{ logicalCores, frequencyMhz, vendor } = PhotoshopCore.getCPUInfo()
var isAMD = vendor === "AMD"
var isARM = vendor === "ARM"
`}</code></pre>
    <hr></hr>
    <h3 {...{
      "id": "getgpuinfo"
    }}>{`getGPUInfo`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/interfaces/gpuinfo/"
      }}><em parentName="a">{`GPUInfo`}</em></a></p>
    <p>{`Returns OpenGL and OpenCL information about the available graphics processor.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{ gpuInfoList, clgpuInfoList } = PhotoshopCore.getGPUInfo()
console.log(JSON.stringify(gpuInfoList))
// > [{"version":"2.1 ATI-4.5.14","memoryMB":8192,"name":"16915464", ...}]
console.log(JSON.stringify(clgpuInfoList))
// > [{"version":"OpenCL 1.2 ","memoryMB":8589,"name":"AMD Radeon Pro 580X Compute Engine", ...}]
`}</code></pre>
    <hr></hr>
    <h3 {...{
      "id": "getmenucommandstate"
    }}>{`getMenuCommandState`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<boolean`}{`>`}</p>
    <p>{`Returns whether a command menu item is available for invoking.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// can a Fill be performed?
var canFill = await PhotoshopCore.getMenuCommandState({ commandID: 1042 })
`}</code></pre>
    <h4 {...{
      "id": "parameters-5"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.commandID`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.scheduling?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Scheduling`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "getmenucommandtitle"
    }}>{`getMenuCommandTitle`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<string`}{`>`}</p>
    <p>{`Returns the localized menu title of the menu command item.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var renameLayerStr = await PhotoshopCore.getMenuCommandTitle({ commandID: 2983 })
`}</code></pre>
    <h4 {...{
      "id": "parameters-6"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.commandID?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.menuID?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.scheduling?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Scheduling`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "getplugininfo"
    }}>{`getPluginInfo`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/interfaces/actiondescriptor/"
      }}><em parentName="a">{`ActionDescriptor`}</em></a>{`>`}</p>
    <p>{`Return information about the execution of the plugin.
This method is intended for developing plugins.
Shipping code should not use this method.`}</p>
    <p>{`The returned information include the following properties:`}</p>
    <p><inlineCode parentName="p">{`numberOfPendingMainThreadTasks`}</inlineCode>{`: Number of pending promises.`}</p>
    <p><inlineCode parentName="p">{`batchPlayCount`}</inlineCode>{`: Number of `}<inlineCode parentName="p">{`batchPlay`}</inlineCode>{` calls since the plugin was loaded.`}</p>
    <p><inlineCode parentName="p">{`mainThreadTimeOutCount`}</inlineCode>{`: Number of JavaScript calls that have timed out.
This is typically caused by executing commands while Photoshop is modal without using
`}<inlineCode parentName="p">{`executeAsModal`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`v8HeapSize`}</inlineCode>{`: V8 heap allocated for the plugin. This number is only accurate
when loading plugins through the UXP Developer Tool.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await PhotoshopCore.getPluginInfo()
`}</code></pre>
    <hr></hr>
    <h3 {...{
      "id": "ismodal"
    }}>{`isModal`}</h3>
    <p><em parentName="p">{`boolean`}</em></p>
    <p>{` Returns true if the plugin is currently in a modal state using `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/media/photoshopcore/#executeasmodal"
      }}>{`executeAsModal`}</a></p>
    <hr></hr>
    <h3 {...{
      "id": "performmenucommand"
    }}>{`performMenuCommand`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<boolean`}{`>`}</p>
    <p>{`Invokes the menu command via its `}<inlineCode parentName="p">{`commandID`}</inlineCode>{`. Returns false
on failure, or if the command is not available.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// select all
await PhotoshopCore.performMenuCommand({ commandID: 1017 })
`}</code></pre>
    <h4 {...{
      "id": "parameters-7"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.commandID`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.scheduling?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Scheduling`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "setexecutionmode"
    }}>{`setExecutionMode`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`The execution mode can be used while debugging a plugin. It is only available
when the developer mode is enabled.`}</p>
    <p>{`The following example illustrate how to enable stacktraces for batchPlay commands
that fail. When stacktraces are enabled, then an error result descriptor from a
batchPlay request will include a stacktrace property. The property can be used when
reporting bugs to Adobe.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await PhotoshopCore.setExecutionMode({ enableErrorStacktraces: true })
`}</code></pre>
    <p>{`The following illustrates how to enable console warnings when a promise is rejected:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await PhotoshopCore.setExecutionMode({ logRejections: true })
`}</code></pre>
    <h4 {...{
      "id": "parameters-8"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.enableErrorStacktraces?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.logRejections?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "setuseridletime"
    }}>{`setUserIdleTime`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Specifies the number of seconds a user must be idle on Photoshop before invoking the
userIdle event handler defined with `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/media/photoshopcore/#addnotificationlistener"
      }}>{`addNotificationListener`}</a>{`. An idleTime of 0
turns off idle notifications.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await PhotoshopCore.setUserIdleTIme(3)
`}</code></pre>
    <h4 {...{
      "id": "parameters-9"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`idleTime`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "showalert"
    }}>{`showAlert`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Show a generic alert box to the user. 'OK' to dismiss.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// script has completed.
await PhotoshopCore.showAlert({ message: 'Operation successful'})
`}</code></pre>
    <h4 {...{
      "id": "parameters-10"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.message`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "translateuistring"
    }}>{`translateUIString`}</h3>
    <p><em parentName="p">{`string`}</em></p>
    <p>{`Given a Photoshop ZString (of format `}<inlineCode parentName="p">{`"$$$/slash/separated/key=english default value"`}</inlineCode>{`),
will return the translated string for the current UI language`}</p>
    <h4 {...{
      "id": "parameters-11"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`zstring`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      